"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.reflect.has");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.number.constructor");
var _trends = require("@/api/cont/trends");
var _admin = require("@/api/admin");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'MultiLanguageInp',
  props: {
    inpDataJSON: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: NaN
    },
    type: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rulesInp: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      inpShow: '',
      nameLang: {},
      inpData: this.inpDataJSON ? JSON.parse(this.inpDataJSON) : {},
      lang: 'zh',
      rules: {},
      languageTranslation: false,
      minLength: '',
      key: '',
      tip: false
    };
  },
  watch: {
    inpDataJSON: {
      handler: function handler(newVal) {
        try {
          this.inpData = newVal && newVal !== '{}' ? JSON.parse(newVal) : {};
          this.getInpShowData();
        } catch (e) {
          console.error('解析inpDataJSON失败:', e);
          this.inpData = {};
          this.inpShow = '';
        }
      },
      immediate: true
    }
  },
  methods: {
    trans: function trans() {
      var _this = this;
      var key = '';
      if (this.nameLang['zh']) {
        key = this.nameLang['zh'];
      } else {
        for (var keyName in this.nameLang) {
          if (this.nameLang.hasOwnProperty(keyName)) {
            if (this.nameLang[keyName]) {
              key = this.nameLang[keyName];
              break; // 中断循环
            }
          }
        }
      }
      if (!key) return;
      var params = {
        key: key
      };
      (0, _trends.languageTranslation)(params).then(function (res) {
        if (res.code === '0' && res.data && Object.keys(res.data).length !== 0) {
          for (var _keyName in _this.nameLang) {
            if (_this.nameLang.hasOwnProperty(_keyName)) {
              _this.$set(_this.nameLang, _keyName, res.data[_keyName]);
            }
          }
        }
      });
    },
    // 打开语种编辑弹窗
    onLanguageVisible: function () {
      var _onLanguageVisible = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _this2 = this;
        var res, item;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.tip = false;
              _context.n = 1;
              return (0, _admin.getLangCode)();
            case 1:
              res = _context.v;
              // 初始化语言字段
              res.data.data && res.data.data.list ? res.data.data.list.forEach(function (item) {
                _this2.$set(_this2.nameLang, item.label, '');
                _this2.rules[item.label] = _this2.rulesInp;
              }) : this.nameLang = {};

              // 填充已有的语言数据
              for (item in this.inpData) {
                if (Reflect.has(this.nameLang, item)) {
                  this.nameLang[item] = this.inpData[item];
                }
              }

              // 如果有输入但没有保存到inpData中，则自动填充到中文字段
              if (this.inpShow && (!this.inpData['zh'] || this.inpData['zh'] !== this.inpShow)) {
                this.nameLang['zh'] = this.inpShow;
              }
              this.languageTranslation = true;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onLanguageVisible() {
        return _onLanguageVisible.apply(this, arguments);
      }
      return onLanguageVisible;
    }(),
    getInpShowData: function getInpShowData() {
      if (Object.getOwnPropertyNames(this.inpData).length !== 0) {
        // 优先显示中文
        if (this.inpData['zh']) {
          this.inpShow = this.inpData['zh'];
          return;
        }

        // 如果没有中文，则查找当前语言
        for (var item in this.inpData) {
          if (this.lang === item.substring(0, 2)) {
            this.inpShow = this.inpData[item];
            return;
          }
        }

        // 如果没有当前语言，则使用第一个非空值
        for (var _item in this.inpData) {
          if (this.inpData[_item]) {
            this.inpShow = this.inpData[_item];
            return;
          }
        }
        this.inpShow = '';
      }
    },
    handleLanguage: function handleLanguage() {
      var _this3 = this;
      console.log(this.nameLang, 'nameh');
      this.inpShow = this.nameLang['zh'];
      this.$refs.nameLang.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(valid) {
          return (0, _regenerator2.default)().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (valid) {
                  // 先更新本地数据
                  _this3.inpData = (0, _objectSpread2.default)({}, _this3.nameLang);
                  // 然后触发外部更新
                  _this3.$emit('updateInp', JSON.stringify(_this3.nameLang));
                  // 关闭弹窗
                  _this3.languageTranslation = false;
                  // 手动触发一次blur事件，确保外层表单能够验证到更新后的值
                  _this3.$nextTick(function () {
                    // 创建并分发blur事件
                    var event = new Event('blur');
                    if (_this3.$el.querySelector('input')) {
                      _this3.$el.querySelector('input').dispatchEvent(event);
                    }

                    // 创建并分发change事件
                    var changeEvent = new Event('change');
                    if (_this3.$el.querySelector('input')) {
                      _this3.$el.querySelector('input').dispatchEvent(changeEvent);
                    }

                    // 通知父组件验证已更新
                    _this3.$emit('validation-updated');
                  });
                }
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    cancelLanguageVisible: function cancelLanguageVisible() {
      this.languageTranslation = false;
    },
    onBlur: function onBlur() {
      // 只有当输入框有值但inpData为空时，才提示用户点击地球图标
      if (this.inpShow && Object.keys(this.inpData).length === 0) {
        this.tip = true;
        return;
      }

      // 如果输入框有值，更新中文字段
      if (this.inpShow) {
        var updatedData = (0, _objectSpread2.default)({}, this.inpData);
        updatedData['zh'] = this.inpShow;
        this.inpData = updatedData;
        this.$emit('updateInp', JSON.stringify(updatedData));
      }

      // 不再自动打开弹窗
      // this.onLanguageVisible()
    } // changeValue(key) {
    //   this.nameLang[key] = this.nameLang[key].replace(/\s+/g, '')
    // }
  }
};